














































































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { orderUsersModule } from '../store/modules/OrderUsers'; // ストアモジュール
import { supervisingModule } from '../../store/modules/OperationSupervising'; // 画面統括モジュール
import { ITree } from '../store/dto/Organization'; // dto
import { IUsers } from '../store/dto/OrderUsers';
import organizationTree from '../components/OrganizationTree.vue'; // ツリーの呼び出し
import TemporarySave from '../../CommonUtils/components/TemporarySave.vue'; // ファイル一時保存機能の呼び出し
import { KanriConstants } from '../fixed/KanriConstants';

// コンポーネント登録
Vue.component('organizationTree', organizationTree);
Vue.component('ApiAccessBase', ApiAccessBase);
Vue.component('TemporarySave', TemporarySave);

@Component
export default class UserInfo extends ApiAccessBase {
  private isCreate: boolean = false;
  private treeValue: ITree = {
    szkCd: '',
    naibCd: '',
    level: '',
    position: '',
  };
  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'ユーザ登録';
    let path = '';
    if (orderUsersModule.CHECK_MOVE_STATE || orderUsersModule.IS_SET_USER) {
      // 編集時
      path = KanriConstants.USER_PATH + orderUsersModule.GET_PATH;
      // orderUsersModule.arrivalToInfo();
    } else {
      // 新規登録時
      path = KanriConstants.USER_PATH + '/init';
      this.isCreate = true;
    }
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['user_info']);
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );
  }
  /**
   * ツリー情報の監視
   * deep: true(ネストされたプロパティも監視する)
   */
  @Watch('treeValue', {deep: true})
  private updateTreeValue(newValue: ITree, oldValue: ITree) {
    this.formData['szkCd'] = newValue.szkCd;
    this.formData['naibCd'] = newValue.naibCd;
    // this.treeSelectFlag = true;
  }

  /**
   * 一時保存データの監視
   * ファイル読込からデータを取得した場合、フォームデータを更新する
   * @param value 一時保存コンポーネントからの戻り値（JSONファイルから読込した値）
   */
  private updateTempValue(value: JSON) {
    this.formData = value;
  }

  /**
   * ユーザ情報登録
   * (登録ボタン押下時に発火)
   */
  private registUser() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    if (window.confirm(Message.I0003)) {
      let path: string = KanriConstants.USER_PATH;
      if (supervisingModule.CHECK_MODE_UPDATE) {
        path += '/update';
      } else {
        path += '/create';
      }

      this.apiAccess(
        path,
        Constants.API_METHOD_POST,
        true,
        false,
      ).then((result) => {
        this.hrefElement('userInfo', -50);
        if (result === Constants.API_RESULT_SUCCES) {
          if (this.isCreate) {
            const user: IUsers = {szkCd: '', naibCd: '', userId: this.formData.userId};
            orderUsersModule.setUsers(user);
            this.isCreate = false;
          }
        } else {
        }
      });
    }
  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    if (supervisingModule.CHECK_MODE_UPDATE) {
      this.apiAccess(KanriConstants.USER_PATH + '/exclusive/delete' + orderUsersModule.GET_PATH, Constants.API_METHOD_POST, false, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          this.back();
        }
      });
    } else {
      this.back();
    }
  }
  private back() {
    if (orderUsersModule.CHECK_MOVE_STATE) {
      orderUsersModule.moduleSelectReset();
      router.push({ name: 'userSearch' });
    } else {
      orderUsersModule.moduleSelectReset();
      router.push({ name: 'userMenu' });
    }
  }
  /**
   * パスワード更新
   */
  private passwordUpdate() {
    router.push({ name: 'userChangePassword' });
  }
}
